import { useEffect } from 'react';
import { usePreproductPreviewContext } from '../context/Context';
import { PREPROD_PREVIEW_ACTIONS, PREPROD_PREVIEW_EVENTS } from '../context/types';
import { isBoardExist, isBoardInitiated } from '../utils/checkBoardCookies';
export var useBoardCreatedListener = function useBoardCreatedListener(embedBoardKey) {
  var _usePreproductPreview = usePreproductPreviewContext(),
      dispatch = _usePreproductPreview.dispatch;

  useEffect(function () {
    var onMessage = function onMessage(event) {
      if (event.data.type === PREPROD_PREVIEW_EVENTS.LITE_BOARD_CREATED) {
        if (isBoardExist(embedBoardKey) && isBoardInitiated(embedBoardKey)) {
          dispatch({
            type: PREPROD_PREVIEW_ACTIONS.SET_IS_BOARD_ACTIVE,
            payload: true
          });
        }
      }
    };

    window.addEventListener('message', onMessage);
    return function () {
      return window.removeEventListener('message', onMessage);
    };
  }, [dispatch]);
};